
exports.install = function (Vue, options) {
    const baseUrl = 'http://api.gzdkzb.com/'
    // const baseUrl = 'http://localhost:7777/'
    Vue.prototype.globalUrl = {
        baseUrl     : baseUrl,
        resourceUrl : 'http://resource.gzdkzb.com/',
        imageUpload : baseUrl+'manage/common/uploadImage',

        navInfo   : baseUrl+'web/common/getNav',
        indexInfo   : baseUrl+'web/common/getIndexInfo',
        cpyInfo   : baseUrl+'web/common/getCpyInfo',
        //采购
        purchaseCategoryList   : baseUrl+'web/common/listPurchaseCategory',
        purchasePage   : baseUrl+'web/common/pagePurchase',
        purchaseFind   : baseUrl+'web/common/findPurchase/',
        //工程项目
        tenderingCategoryList   : baseUrl+'web/common/listTenderingCategory',
        tenderingPage   : baseUrl+'web/common/pageTendering',
        tenderingFind   : baseUrl+'web/common/findTendering/',
        //政策
        policyPage   : baseUrl+'web/common/pagePolicy',
        policyFind   : baseUrl+'web/common/findPolicy/',
        //收费标准
        feePage   : baseUrl+'web/common/pageFee',
        feeFind   : baseUrl+'web/common/findFee/',

        //公司业绩
        cpyResultCategoryList   : baseUrl+'web/common/listResultCategory',
        cpyResultPage   : baseUrl+'web/common/pageResult',
        cpyResultFind   : baseUrl+'web/common/findResult/',


    }
};



// WEBPACK FOOTER //
// ./src/configs/globalUrl.js